module.exports = __webpack_public_path__ + "static/selim-goksin-c7987ef93ea1c69241b89d567a3621ec.jpg";